/* eslint-disable web/require-manifest-link -- The PWA manifest is wired statically in apps/purchase-web/marketing.html via <link rel="manifest" href="/manifest.json" />. */

/**
 * Marketing Website Entry Point — Phase O.5 (purchase-web migration).
 *
 * Bootstrap file for the PurchasePuffin public marketing website
 * (marketing.html is the second Vite entry point). The createMarketingApp
 * factory now owns the BrowserRouter + I18nextProvider + CookieConsent
 * + Analytics + MarketingShell chrome, leaving this file as a thin wrapper
 * around marketing-shell's `mountMarketingRoot` behind the entry's telemetry bootstrap.
 *
 * @module portals/marketing-website/main
 */

// UNREACHABLE-MODULE-BURNDOWN-001 Q-UMB-13 — SIDE-EFFECT import, deliberately FIRST: it installs
// `@puffin-core/logging-browser`'s uncaught-error capture and web-vitals collector before any module
// below evaluates. It replaced a `createErrorReporter` with no transport (a structured no-op) and a
// hand-rolled PerformanceObserver that reported raw entry timestamps as exceptions to it.
import './telemetry';
import { mountMarketingRoot } from '@puffin-core/marketing-shell';
import { MarketingWebsiteApp } from './MarketingWebsiteApp';
import i18n from './i18n/i18n';
import '../../shared/styles/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Failed to find the root element. ' +
      'Make sure there is a <div id="root"></div> in your HTML.',
  );
}

// MSSG-001 / BLOG-STD-001 — server markup (the build-time prerender, or a blog page rendered by
// marketing-cms) is HYDRATED in the language it was rendered in and then moves to the visitor's; a
// document without it mounts fresh. The ONE implementation is marketing-shell's (Q-LC24-7): nine
// copies of this branch hydrated in the visitor's language, and every Spanish-preferring visit to an
// English prerendered page threw React #418.
mountMarketingRoot({ rootElement, app: <MarketingWebsiteApp />, i18n });
